<template>
  <k-dialog>
    <div class="dialog-wrapper dialog-readtip-wrapper">
      <a
        class="dialog-btn-close"
        @click="$store.commit('CLOSE_DIALOG', 'AnswerTip')"
      ></a>
      <div class="title"></div>
      <div class="answer-box">
        <p class="title-tip">答案隐藏在游戏介绍页中，仔细去找找看吧</p>
        <p class="question">{{ view?.topic || '' }}</p>
        <ul class="answer-list" :class="{ single: answerList.length < 4 }">
          <li
            v-for="(item, index) in answerList"
            :key="index"
            :class="{
              right: selectIndex == index && isRight,
              error: selectIndex == index && isError
            }"
            @click="onSelect(index, item)"
          >
            <div class="answer-item">
              {{ optionMaps[index] }}. {{ item.text }}
              <transition name="answer-scale">
                <i
                  v-if="selectIndex == index && isRight"
                  class="icon-answer-status icon-answer-right"
                ></i>
              </transition>
              <i
                v-if="selectIndex == index && isError"
                class="icon-answer-status icon-answer-error"
              ></i>
            </div>
          </li>
        </ul>
      </div>
      <div class="answer-num">
        你有<span>{{ quizChance || 0 }}次</span>答题机会
      </div>
      <div class="prize-show">
        <div class="show-title"><span>奖品展示</span></div>
        <img class="prize-list" :src="img" />
      </div>
    </div>
  </k-dialog>
</template>
<script>
import KDialog from '@com/base/Dialog';
export default {
  name: 'AnswerTip',
  props: {
    img: {
      type: String,
      default: () => ''
    },
    view: {
      type: Object,
      default: () => {}
    },
    moduleId: {
      type: Number
    },
    quizChance: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      question_answer: {},
      optionMaps: ['A', 'B', 'C', 'D'],
      selectIndex: -1,
      isRight: false,
      isError: false,
      isLockSelect: false
    };
  },
  computed: {
    answerList() {
      const list = [];
      if (this.question_answer) {
        for (let key in this.question_answer) {
          list.push({
            option: key,
            text: `${this.question_answer[key]}`
          });
        }
      }
      list.sort(() => (Math.random() > 0.5 ? 1 : -1));
      return list;
    },
    state() {
      return this.$store.state;
    }
  },
  mounted() {
    let questions = [...this.view.wrong_answer, this.view.correct_answer];
    //{A: 'x', B: 'x', C: 'x', D: 'x'}
    this.question_answer = this.optionMaps.reduce((acc, curr, index) => {
      let curQuestion = questions[index];
      if (curQuestion != undefined && curQuestion != '') {
        acc[curr] = questions[index];
      }
      return acc;
    }, {});
  },
  components: {
    KDialog
  },
  methods: {
    //答题抽奖
    onSelect(index, option) {
      this.isRight = false;
      this.isError = false;

      if (this.state.userInfo.guid === '') {
        this.$store.commit('OPEN_DIALOG', 'Guid');
        return false;
      }
      if (!this.canBeAnswer()) {
        return false;
      }
      this.isLockSelect = true;
      this.selectIndex = index;
      this.drawPrize(option);
    },
    //请求服务端抽奖
    async drawPrize(option) {
      let { code, data } = await this.$api.prize.drawPrize({
        module_id: this.moduleId,
        guid: this.state.userInfo.guid,
        server_id: this.state.userInfo.server_id,
        role_id: this.state.userInfo.role_id,
        ext_params: {
          topic_answer: option.text
        }
      });
      //10003:答案错误，10004：答题次数用完
      if (code !== 0 && code != 10003) {
        this.isLockSelect = false;
        return;
      }
      this.Track(4, this.moduleId);
      this.$emit('change-chance');
      //答错
      if (code == 10003) {
        this.isError = true;
        await this.delay(1000);
        this.$store.commit('CLOSE_DIALOG', 'AnswerTip');
        this.$store.commit('OPEN_DIALOG', 'AnswerError');
        return false;
      }
      //答对
      this.$store.commit('UPDATE_PRIZE', data);
      this.isRight = true;
      await this.delay(1000);
      this.$store.commit('CLOSE_DIALOG', 'AnswerTip');
      this.runAni();
    },
    // 判断是否可以答题
    canBeAnswer() {
      if (this.quizChance <= 0) {
        this.$store.commit('CLOSE_DIALOG', 'AnswerTip');
        this.$store.commit('OPEN_DIALOG', 'NoNum');
        return false;
      }
      if (this.isLockSelect) {
        return false;
      }
      return true;
    },
    // 延迟函数
    async delay(time = 2000) {
      return new Promise((res) => {
        setTimeout(() => {
          res();
        }, time);
      });
    },
    async runAni() {
      this.$store.commit('OPEN_DIALOG', 'AnswerEffect');
      await this.delay(3000);
      this.$store.commit('CLOSE_DIALOG', 'AnswerEffect');
      this.endTurns();
    },
    endTurns() {
      // 中奖
      this.$store.commit('OPEN_DIALOG', 'Prize');
      // 解锁
      this.isLockSelect = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-readtip-wrapper {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 501;
  .title {
    width: 196px;
    height: 45px;
    margin: 0 auto;
    background: url('@/assets/imgs/answer/title.png') no-repeat center/100% 100%;
  }
  .answer-box {
    p {
      color: #333;
      font-size: 24px;
      &.title-tip {
        margin-top: 30px;
      }
      &.question {
        margin-top: 40px;
        text-align: left;
        line-height: 35px;
      }
    }
  }
  .answer-num {
    font-size: 24px;
    color: #666;
    span {
      color: #ffc341;
      font-weight: bold;
    }
  }
  .answer-list {
    margin-top: 25px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    li {
      flex: 0 0 46%;
      text-align: left;
      background: #f5f5f5;
      line-height: 70px;
      padding-left: 25px;
      border-radius: 50px;
      color: #000;
      font-size: 24px;
      margin-bottom: 25px;
      .answer-item {
        position: relative;
      }
      &.right {
        background: #0dcda5;
        color: #fff;
      }
      &.error {
        background: #ff6867;
        color: #fff;
        animation: answer-shake 800ms both;
      }
    }
    &.single {
      li {
        flex: 0 0 100%;
        display: block;
      }
    }
    .icon-answer-status {
      display: block;
      position: absolute;
      right: 25px;
      top: 50%;
      transform: translateY(-50%);
    }
    .icon-answer-right {
      width: 19px;
      height: 19px;
      background: url('@/assets/imgs/answer/icon-answer-right.png') no-repeat
        center/100%;
    }
    .icon-answer-error {
      width: 19px;
      height: 19px;
      background: url('@/assets/imgs/answer/icon-answer-error.png') no-repeat
        center/100%;
    }
  }
}
.prize-show {
  margin: 44px auto 0;
  .show-title {
    position: relative;
    border-top: 1px solid #666;
    width: 300px;
    height: 30px;
    margin: 0 auto 20px;
    span {
      position: absolute;
      width: 150px;
      top: -12px;
      left: 50%;
      display: block;
      background: #fff;
      color: #666;
      font-size: 24px;
      text-align: center;
      transform: translateX(-50%);
    }
  }
  .prize-list {
    display: block;
    width: 100%;
  }
}
.answer-scale-enter-active {
  animation: answer-scale 300ms linear;
}
</style>
<style lang="scss">
@keyframes answer-shake {
  from,
  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  10%,
  30%,
  50%,
  70%,
  90% {
    -webkit-transform: translate3d(-0.1rem, 0, 0);
    transform: translate3d(-0.1rem, 0, 0);
  }
  20%,
  40%,
  60%,
  80% {
    -webkit-transform: translate3d(0.1rem, 0, 0);
    transform: translate3d(0.1rem, 0, 0);
  }
}
@keyframes answer-scale {
  0% {
    -webkit-transform: scale(0.5) translateY(-50%);
    transform: scale(0.5) translateY(-50%);
  }

  35% {
    -webkit-transform: scale(1) translateY(-50%);
    transform: scale(1) translateY(-50%);
  }

  75% {
    -webkit-transform: scale(1.6) translateY(-50%);
    transform: scale(1.6) translateY(-50%);
  }

  100% {
    -webkit-transform: scale(1) translateY(-50%);
    transform: scale(1) translateY(-50%);
  }
}
</style>
